import { motion } from "framer-motion";
import { HEADING_TOP } from "../layout";

interface ScreenHeadingProps {
  /** Small italic serif line above the headline — opens a new act. */
  kicker?: string;
  title: string;
  subtitle?: string;
}

/**
 * The heading block shared by every question screen: optional act kicker,
 * the italic serif headline, optional sub-line. One component so type scale
 * and rhythm stay identical across the flow (and so an experiment can retune
 * all of it from one place).
 */
export default function ScreenHeading({
  kicker,
  title,
  subtitle,
}: ScreenHeadingProps) {
  return (
    <div className={HEADING_TOP}>
      {kicker && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="font-display font-medium text-[16px] leading-snug text-neutral-500 dark:text-neutral-400 mb-2"
        >
          {kicker}
        </motion.p>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="font-display font-semibold text-[28px] leading-[1.16] tracking-tight text-neutral-900 dark:text-neutral-50"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.3 }}
          className="text-[13px] leading-relaxed text-neutral-500 dark:text-neutral-400 mt-2"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
